<template>
  <div class="dove-siamo">

    <overlay-back/>

    <GmapMap
      :center="{lat:43.4608801, lng:11.1119925}"
      :zoom="14"
      :options="{styles: compMapStyles}"
      map-type-id="roadmap">
      <GmapMarker
        :position="{lat:43.4608801, lng:11.1119925}"
        :clickable="true"
        :icon="{url: require('@/assets/components/ContactsLocationCta/marker-2025.svg')}"
      />
    </GmapMap>

    <div class="default-container" style="height: 100%;">
      <div class="dove-siamo__content">
        <h1 v-html="typeof pageApiData !== 'undefined' ? pageApiData.title : ''"></h1>
        <div v-html="typeof pageApiData !== 'undefined' ? pageApiData.content : ''"></div>
        <a href="https://maps.app.goo.gl/Kw5nQ8xWuwXxRBeu6" target="_blank" rel="noopener" class="link-triangle-effect">
          {{ $t('openOnGoogle') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import { mapGetters } from 'vuex'

import OverlayBack from '@/components/OverlayBack'
const mapStyles = require('@/map/styles.json')

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBoJx6G2VttaWpaWvfQ3iaYPUBEGjChX-U'
  }
})

export default {
  mixins: [ lang, dataLoad ],
  components: {
    OverlayBack
  },
  computed: {
    ...mapGetters([
      'viewport'
    ]),
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    compMapStyles: {
      get () {
        return mapStyles
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .dove-siamo{
    position: fixed;
    top: 0;
    z-index: 175;
    height: 100vh;
    width: 100%;
    background-color: #1d1d1b;
    @media #{$medium_mq} {
      background-position: left center;
    }

    .dove-siamo__content{
      display: none;
      @media #{$large_mq} {
        display: block;
      }
      position: absolute;
      top: 50%;
      transform: translate3d(0, -60%, 0);

      h1{
        @include hero-title(#EFEFF1);
        text-transform: uppercase;
        br{
          display: none;
          @media #{$large_mq} {
            display: block;
          }
        }
      }

      li{
        @include size-18-pixel(#EFEFF1);
        line-height: 1.8;
        font-family: 'Roboto', sans-serif;
        font-weight: 300;
        color: #EFEFF1;
      }

      a{
        color: #EFEFF1;
        text-decoration: none;
      }

    }

    .link-triangle-effect{
      margin-top: 4rem;
      @include link-triangle-effect(#EFEFF1);
    }

  }

  .vue-map-container{
    position: absolute;
    right: 0; top: 0; width: 100%; height: 100%;

    @media #{$large_mq} {
      width: 60%; height: 100%;
      z-index: 10;
    }

  }

  .dove-siamo .hamburger-menu-container::before{
    top: 46%;
    left: 44%;
  }

  .gmnoprint, .gmnoscreen, .gm-style-cc, .gmnoprint, .gm-fullscreen-control, a[rel='noopener']{
    display: none;
  }

</style>
